import React, { useMemo, useState, useEffect, Fragment } from "react";
import Table from "./Table";
import "../App.css";
import axios from 'axios'
import config from '../config'
import Media from 'react-media';
import CardList from "./CardList";
 
const Card = ({ data }) => {
  return (
           <section className="text-card">
              <CardList vehicleInfo = {data} />
           </section>
         )
}
const Cards = ({ data }) => {
  return data.map(vehicleInfo => {
    return <Card key={vehicleInfo.continuationUrl } data={vehicleInfo} />
  })
}

function Relocations() {
  const [data, setData] = useState([]);
  const Depots = ({ values }) => {
    return (
      <>
        {values.map((depot, idx) => {
          return (
            <span key={idx} className="badge">
              {depot.name}
            </span>
          );
        })}
      </>
    );
  };

  const columns = useMemo(
    () => [
   
      {
        Header: "Relocations",
           columns: [
          {
            Header: "FROM",
            accessor: "fromDepots",
            Cell: ({ cell: { value } }) => <Depots values={value} />
          },
          {
            Header: "TO",
            accessor: "toDepots",
            Cell: ({ cell: { value } }) => <Depots values={value} />
          },
          {
            Header: "PICK UP FROM",
            accessor: "earliestStartDateTime",
            Cell: ({ cell: { value } }) => {
              const date = new Date(value);
              return `${date.getUTCDate()}/${date.getUTCMonth()+1}/${date.getUTCFullYear()}`
            }
          },
          {
            Header: "DROP OFF BY",
            accessor: "latestEndDateTime",
            Cell: ({ cell: { value } }) => {
              const date = new Date(value);
              return `${date.getUTCDate()}/${date.getUTCMonth()+1}/${date.getUTCFullYear()}`
            }
          },
        
          {
            Header: "VEHICLE",
            accessor: "product.name",
            },
           
          {
            Header: "INCLUSIONS",
            accessor: "detail",
            Cell: ({ cell: { value } }) => {
              let response = [];
              if (value.fuel_allowance) {
                response.push(`Fuel allowance $${value.fuel_allowance}`);
              }
              if (value.general_allowance) {
                response.push(`General allowance $${value.general_allowance}`);
              }
              if (value.refund) {
                response.push(`Refund of ${value.refund} after dropoff`);
              }
              if (value.ship_pax && value.shop_pax > 0) {
                response.push(`Includes prebooked ship`);
              }
              
              if (value.free_fuel === 1 ) {
                response.push(`Free fuel`);
              }

              if (response.length > 1) {
                return response.join(', ');
              }
              if (response.length) {
                return response[0];
              }
              return '';
            }
            },
            {
              Header: "RATE FROM",
              accessor: "detail.price_per_day",
              Cell: ({ cell: { value } }) => {
               return `$${value}/day`
              }
            },
          {
            Header: "",
            accessor: "continuationUrl",
            Cell: ({ cell: { value } }) => ( 
            <button
              type="button"
              className="reloc-button"
              onClick={(e) => {
              e.preventDefault();
              window.location.href=value;
            }}> Book Offer</button>)  
          }
        ]
      }
    ],
    []
  );
  useEffect(() => {
     
     let countryCode = ((document.querySelector('#root').getAttribute('data-country')));
          if (!countryCode || 0 === countryCode.length || countryCode.includes('[ModuleContext:Country]') )
          {
            countryCode = 'AU';
          }  
         
      (async () => {
     const result = await axios.get(config.API_URL+countryCode)
       .catch(err => {console.log(err)})
        setData(result.data);
    })();
  }, []);

  return (
    <div className="App">
     <Media queries={{
          small: "(max-width: 599px)",
          medium: "(min-width: 600px) and (max-width: 1199px)",
          large: "(min-width: 1200px)"
        }}>
          {matches => (
            <Fragment>
              {(matches.small || matches.medium) && data && <Cards data={data} />}
              {matches.large && (data && columns) && <Table columns={columns} data={data} />}
            </Fragment>
          )}
        </Media>

    </div>
  );
}
export default Relocations;